<template>
<jet-dialog-modal :show="isDistributorModel"  @close="closeDistributorPopup" :max-width="'3xl'">
      <template #title>
        <div class="flex justify-between items-center text-xl font-bold">
          Attach Distributor
        </div>
      </template>

      <template #content>
        <div class="max-w-7xl mx-auto space-y-8">

  <!-- FORM HEADER -->
  <div class="bg-white p-6 shadow rounded-xl space-y-6">

    <!-- Select Box -->
    <div>
      <label class="block text-sm font-medium mb-1">Select Distributor</label>
      <div class="relative focus:outline-none sm:w-80 w-60 xl:pl-0 pl-0 xl:mt-0 mt-4">

                <select v-model="selectedDistributorId" @change="getDidtributorItems"
                  class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height 2xl:text-base text-base text-gray-400">
                  <option value="">-- Select Distributor --</option>
        <option v-for="value in all_distributors" :value="value.id" @change="getDidtributorItems(value.id)">{{ value.name }}</option>
                </select>
                <div
                  class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
              </div>
    </div>

    <!-- Radio Buttons -->
    <div class="space-y-3" >
      <label class="block text-sm font-medium">Item Type</label>
      <div class="flex items-center gap-6">
        <label class="flex items-center gap-2 cursor-pointer">
          <input type="radio" name="item_type" v-model="item_type" value="exist" class="h-4 w-4">
          <span>Exist Items</span>
        </label>


        <label class="flex items-center gap-2 cursor-pointer">
          <input type="radio" name="item_type" v-model="item_type" value="new" class="h-4 w-4">
          <span>Is New Item</span>
        </label>

      </div>
    </div>

  </div>

  <!-- ITEMS TABLE -->
  <div class="bg-white p-6 shadow rounded-xl " v-if="item_type === 'exist' && selectedDistributorId != ''">
    <h2 class="text-lg font-semibold mb-4">Items List</h2>

    <div class="overflow-auto max-h-96">

    <table class="w-full min-w-max border ">
      <thead class="bg-gray-100 text-sm">
        <tr>
          <th class="border px-2 py-2">ACTIONS</th>
          <th class="border px-2 py-2">DISTRIBUTOR NUMBER</th>
          <th class="border px-2 py-2">UPC</th>
          <th class="border px-2 py-2">CASE COST ($)</th>
          <th class="border px-2 py-2">CASE WEIGHT</th>
          <th class="border px-2 py-2">CASE WEIGHT UOM</th>
          <th class="border px-2 py-2">SUB CASE WEIGHT</th>
          <th class="border px-2 py-2">CASE VOLUME</th>
          <th class="border px-2 py-2">CASE VOLUME UOM</th>
          <th class="border px-2 py-2">SUB CASE VOLUME</th>
          <th class="border px-2 py-2">CASE QTY</th>
          <th class="border px-2 py-2">SUB CASE QTY</th>
        </tr>
      </thead>
      <tbody class="text-sm">
        <tr v-if="items.length === 0">
          <td colspan="12" class="border px-2 py-2 ">No Items found</td>
        </tr>
        <tr v-for="value in items">
          <td class="border px-2 py-2 text-center">
            <input type="radio" name="selectedItem" v-model="selectedItem" :value="value" />
          </td>
          <td class="border px-2 py-2">{{ value.item_number }}</td>
          <td class="border px-2 py-2">{{ value.upc }}</td>
          <td class="border px-2 py-2">{{ value.case_cost }}</td>
          <td class="border px-2 py-2">{{ value.case_weight }}</td>
          <td class="border px-2 py-2">{{ value.case_weight_uom }}</td>
          <td class="border px-2 py-2">{{ value.sub_case_weight }}</td>
          <td class="border px-2 py-2">{{ value.case_volume }}</td>
          <td class="border px-2 py-2">{{ value.case_volume_uom }}</td>
          <td class="border px-2 py-2">{{ value.sub_case_volume }}</td>
          <td class="border px-2 py-2">{{ value.case_qty }}</td>
          <td class="border px-2 py-2">{{ value.sub_case_qty }}</td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>


  <!-- FORM TO ADD/EDIT ITEM -->
  <div class="bg-white p-6 shadow rounded-xl space-y-6" v-if="item_type === 'new' && selectedDistributorId != ''">
    <h2 class="text-lg font-semibold">Add Item</h2>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div>
        <label class="block text-sm font-medium mb-1 required">Distributor Number</label>
        <input type="text" required v-model="disForm.item_number" class="w-full border px-3 py-2 rounded-lg">
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">UPC</label>
        <input type="text" v-model="disForm.upc" class="w-full border px-3 py-2 rounded-lg">
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Case Cost ($)</label>
        <input type="text" v-model="disForm.case_cost" class="w-full border px-3 py-2 rounded-lg">
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
      <div>
        <label class="block text-sm font-medium mb-1 required">Case Weight</label>
        <input type="number" min="0" step="1" v-model="disForm.case_weight" class="w-full border px-3 py-2 rounded-lg">
      </div>

      <div>
        <label class="block text-sm font-medium mb-1 required">Case Weight UOM</label>
        <div class="relative focus:outline-none">
          <select v-model="disForm.case_weight_uom" class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height 2xl:text-base text-base">
            <option value="">-- Select UOM --</option>
            <option v-for="uom in weight_uoms" :value="uom">{{ uom }}</option>
          </select>
          <div class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>
      </div>

      <div>
        <label class="block text-sm font-medium mb-1 ">Sub Case Weight</label>
        <input type="number" min="0" step="1" v-model="disForm.sub_case_weight" class="w-full border px-3 py-2 rounded-lg">
      </div>

      <div>
        <label class="block text-sm font-medium mb-1 ">Sub Case Weight UOM</label>
        <div class="relative focus:outline-none">
          <select v-model="disForm.sub_case_weight_uom" class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height 2xl:text-base text-base">
            <option value="">-- Select UOM --</option>
            <option v-for="uom in weight_uoms" :value="uom">{{ uom }}</option>
          </select>
          <div class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
      <div>
        <label class="block text-sm font-medium mb-1 ">Case Volume </label>
        <input type="number" min="0" step="1" v-model="disForm.case_volume" class="w-full border px-3 py-2 rounded-lg">
      </div>

      <div>
        <label class="block text-sm font-medium mb-1 ">Case Volume UOM</label>
        <div class="relative focus:outline-none">
          <select v-model="disForm.case_volume_uom" class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height 2xl:text-base text-base">
            <option value="">-- Select UOM --</option>
            <option v-for="uom in volume_uoms" :value="uom">{{ uom }}</option>
          </select>
          <div class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>
      </div>

      <div>
        <label class="block text-sm font-medium mb-1 ">Sub Case Volume</label>
        <input type="number" min="0" step="1" v-model="disForm.sub_case_volume" class="w-full border px-3 py-2 rounded-lg">
      </div>

      <div>
        <label class="block text-sm font-medium mb-1 ">Sub Case Volume UOM</label>
        <div class="relative focus:outline-none">
          <select v-model="disForm.sub_case_volume_uom" class="shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg w-full select-menu-height 2xl:text-base text-base">
            <option value="">-- Select UOM --</option>
            <option v-for="uom in volume_uoms" :value="uom">{{ uom }}</option>
          </select>
          <div class="absolute flex justify-center items-center searching-background-color select-menu-height w-9 text-white top-0 right-0 rounded-lg rounded-tl-none rounded-bl-none pointer-events-none">
            <i class="fa fa-sort-desc" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <div>
        <label class="block text-sm font-medium mb-1">Case Quantity</label>
        <input type="number" min="0" step="1" v-model="disForm.case_qty" class="w-full border px-3 py-2 rounded-lg">
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Sub Case Quantity</label>
        <input type="number" min="0" step="1" v-model="disForm.sub_case_qty" class="w-full border px-3 py-2 rounded-lg">
      </div>
    </div>

  </div>

</div>


      </template>

      <template #footer>
        <div class="flex justify-end items-center">
          <button v-if="item_type === 'exist'" @click="sendToProductPage"
            class="inline-flex justify-center rounded-md font-bold px-4 py-2 uppercase bg-red-500 text-white text-base">Attach</button>

            <button v-if="item_type === 'new'" @click="saveToDistributorItem"
            class="inline-flex justify-center rounded-md font-bold px-4 py-2 uppercase bg-red-500 text-white text-base">Add & Attach </button>
        </div>
      </template>
    </jet-dialog-modal>
</template>

<script>
import JetDialogModal from '@/Jetstream/DialogModal';
import axios from 'axios';
export default {
  name: "AttachDistributor",
  props : [
    'all_distributors'],
  components: {
    JetDialogModal,
  },
  data() {
    return {
      isDistributorModel: true,
      items: [],
      selectedDistributorId: '',
      item_type: 'exist',
      selectedItem: null,
      weight_uoms: ['Ounce', 'Gram', 'LB', 'Kilogram', 'Milligram'],
      volume_uoms: ['Gallon', 'Quart', 'Pint', 'Cup', 'Fluid Ounce', 'Tablespoon', 'Teaspoon', 'Litre', 'Millilitre'],
      disForm : this.$inertia.form({
        distributor_id : '',
        item_number : '',
        upc: '',
        case_cost: '',
        case_weight: '',
        case_weight_uom: '',
        sub_case_weight: '',
        sub_case_weight_uom: '',
        case_volume: '',
        case_volume_uom: '',
        sub_case_volume: '',
        sub_case_volume_uom: '',
        case_qty: '',
        sub_case_qty: ''
      })
    };
  },
  methods: {

    getDidtributorItems() {
      // Logic to get distributor data
      if(!this.selectedDistributorId) {
        this.items = [];

        return;
      }
      axios.get( `/get-distributor-items/${this.selectedDistributorId}`)
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.error('Error fetching distributor items:', error);
        });
    },
    sendToProductPage(){
      let itemData = this.selectedItem;
      if(!itemData){
        this.$toast.error('Please select a distributor item to attach');
        return;
      }
      itemData.distributor = {'id' : this.selectedDistributorId, 'name' : this.all_distributors.find(d => d.id === this.selectedDistributorId).name};
      this.$emit('attach-distributor-item', itemData);
      this.closeDistributorPopup();
    },
    closeDistributorPopup() {
      this.items = [];
      this.selectedDistributorId = '';
      this.item_type = 'exist';
      this.selectedItem = null;
      this.$emit('close');
    },
    saveToDistributorItem(){
      // require validation
      if (!this.disForm.item_number || !this.disForm.case_weight || !this.disForm.case_weight_uom) {
        this.$toast.error('Please fill all required fields');
        return;
      }


      this.disForm.distributor_id = this.selectedDistributorId;

      axios.post('/save-distributor-items', this.disForm).then((response) => {
        // console.log(responce);
        let itemData = response.data;
        // let itemData = this.disForm;
        itemData.distributor = {'id' : this.selectedDistributorId, 'name' : this.all_distributors.find(d => d.id === this.selectedDistributorId).name};
        this.$emit('attach-distributor-item', itemData);
        this.closeDistributorPopup();
      });

      // this.disForm.post('/save-distributor-items').then((responce) => {
      //   console.log(responce);
      //   // let itemData = responce.data;
      //   // // let itemData = this.disForm;
      //   // itemData.distributor = {'id' : this.selectedDistributorId, 'name' : this.all_distributors.find(d => d.id === this.selectedDistributorId).name};
      //   // this.$emit('attach-distributor-item', itemData);
      //   // this.closeDistributorPopup();
      // });
    }
  }
}
</script>
